import script from "./PartialInvoiceGeneralTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PartialInvoiceGeneralTable.vue?vue&type=script&setup=true&lang=js"

import "./PartialInvoiceGeneralTable.vue?vue&type=style&index=0&id=2cf88a96&lang=css"

const __exports__ = script;

export default __exports__